import { useRef } from "react";
import { Canvas, useFrame } from "@react-three/fiber";
import { PresentationControls, Edges } from "@react-three/drei";
import * as THREE from "three";

function CubeGeometry() {
  const groupRef = useRef<THREE.Group>(null);

  useFrame(() => {
    if (groupRef.current) {
      groupRef.current.rotation.x += 0.003;
      groupRef.current.rotation.y += 0.005;
    }
  });

  const colors = [
    0xffd700, // Yellow
    0x00ff00, // Green
    0xff0000, // Red
    0x0099ff, // Blue
    0xffffff, // White
    0xff9900, // Orange
  ];

  const cubelets = [];
  for (let x = -1; x <= 1; x++) {
    for (let y = -1; y <= 1; y++) {
      for (let z = -1; z <= 1; z++) {
        cubelets.push({ x, y, z });
      }
    }
  }

  return (
    <group ref={groupRef}>
      {cubelets.map((pos, idx) => (
        <mesh key={idx} position={[pos.x, pos.y, pos.z]}>
          <boxGeometry args={[0.95, 0.95, 0.95]} />
          <meshStandardMaterial
            color={colors[idx % colors.length]}
            metalness={0.3}
            roughness={0.4}
          />
          <Edges scale={1.05} threshold={15} color="#000" />
        </mesh>
      ))}
    </group>
  );
}

export function RubiksCube() {
  return (
    <Canvas camera={{ position: [0, 0, 4], fov: 50 }} style={{ height: "100%" }}>
      <ambientLight intensity={0.8} />
      <pointLight position={[10, 10, 10]} intensity={1} />
      <pointLight position={[-10, -10, -10]} intensity={0.5} />
      <PresentationControls
        speed={1.5}
        global
        zoom={1}
        rotation={[0, 0, 0]}
      >
        <CubeGeometry />
      </PresentationControls>
    </Canvas>
  );
}